import type { Component, InjectionKey } from 'vue'
import type { IconKey } from './icons'

/** An app can supply its own icon family without changing other UI consumers. */
export type AppIconOverrides = Readonly<Partial<Record<IconKey, Component>>>

export const appIconOverridesKey: InjectionKey<AppIconOverrides> = Symbol('app-icon-overrides')
